<template>
  <Card>
    <template #title="">
      <div class="p-d-flex p-justify-between">
        เอกสารอบรมต้นสังกัด
        <div>
          <Button
            label="สร้างใหม่"
            icon="pi pi-plus"
            @click="onNewDocument"
          ></Button>
          <BackButton class="p-ml-2" />
        </div>
      </div>
    </template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-md-4 p-fluid">
          <span class="p-float-label">
            <Calendar
              id="calendar"
              selectionMode="range"
              v-model="selectedDate"
            ></Calendar>
            <label for="calendar">ระบุวันที่ค้นหาเอกสาร</label>
          </span>
        </div>
        <div class="p-col-12 p-lg-3 p-md-4 p-fluid">
          <span class="p-float-label">
            <Dropdown
              id="department"
              :options="departments"
              optionValue="code"
              optionLabel="description"
              v-model="department"
              showClear
            ></Dropdown>
            <label for="department">Department</label>
          </span>
        </div>
        <div class="p-col-12 p-lg-3 p-md-4 p-fluid">
          <span class="p-float-label">
            <Dropdown
              id="division"
              :options="divisions"
              optionValue="code"
              optionLabel="description"
              v-model="division"
              showClear
            ></Dropdown>
            <label for="division">Division</label>
          </span>
        </div>
        <div class="p-col-fixed">
          <Button
            label="ค้นหา"
            icon="pi pi-search"
            @click="onSearchDocuments"
          />
        </div>
        <div class="p-col-12">
          <DataTable :value="onTheJobs" class="p-datatable-sm">
            <template #empty="">ไม่พบข้อมูล</template>
            <Column header="รหัสเอกสาร" field="id"></Column>
            <Column header="หัวข้ออบรม" field="course.description"></Column>
            <Column header="สร้างโดย" field="createById">
              <template #body="props">
                <span v-if="props.data.createBy">
                  {{ props.data.createBy.prename
                  }}{{ props.data.createBy.name }}
                  {{ props.data.createBy.surname }}
                </span>
              </template>
            </Column>

            <Column header="Department" field="course.createBy.departmentCode">
              <template #body="props">
                {{
                  props.data.createBy
                    ? `${props.data.createBy.departmentCode} : ${props.data.createBy.departmentDescription}`
                    : "N/A"
                }}
              </template>
            </Column>
            <Column header="Division" field="course.createBy.divisionCode">
              <template #body="props">
                {{
                  props.data.createBy
                    ? `${props.data.createBy.divisionCode} : ${props.data.createBy.divisionDescription}`
                    : "N/A"
                }}
              </template>
            </Column>
            <Column header="วันที่เอกสาร">
              <template #body="props">
                {{ formatAppDate(props.data.documentDate) }}
              </template>
            </Column>
            <Column header="สถานะ" field="status">
              <template #body="props">
                <StatusBadge :status="props.data.status" />
              </template>
            </Column>
            <Column headerStyle="width: 4rem" bodyStyle="width:4rem">
              <template #body="props">
                <Button
                  class="p-button-rounded p-button-success"
                  @click="onEditDocument(props.data.id)"
                  icon="pi pi-pencil"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import {
  OnthejobDocument,
  GetOnTheJobDocumentRequest,
  GetOnTheJobDocumentResponse,
  DropdownDto,
} from "@/types";
import StatusBadge from "@/components/StatusBadge.vue";

export default defineComponent({
  name: "OnTheJobDocumentList",
  components: { StatusBadge },
  setup() {
    const {
      axios,
      error,
      success,
      setLoading,
      dayjs,
      onRouterPush,
      formatAppDate,
    } = usePlugin();
    const selectedDate = ref<Date[]>([
      dayjs()
        .startOf("month")
        .toDate(),
      dayjs()
        .endOf("month")
        .toDate(),
    ]);
    const division = ref(null);
    const department = ref(null);
    const onTheJobs = ref<OnthejobDocument[]>([]);
    const divisions = ref<DropdownDto[]>([]);
    const departments = ref<DropdownDto[]>([]);

    const onSearchDocuments = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetOnTheJobDocumentResponse>(
          "api/v1/services/onTheJobDocument",
          {
            fromDate: selectedDate.value[0],
            toDate: selectedDate.value[1],
            division: division.value,
            department: department.value,
          } as GetOnTheJobDocumentRequest
        );
        onTheJobs.value = result.data.onTheJobDocuments ?? [];
        divisions.value = result.data.divisions;
        departments.value = result.data.departments;
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onEditDocument = (id: string) => {
      onRouterPush({ name: "editOnTheJobDocument", params: { id: id } });
    };

    const onNewDocument = () => {
      onRouterPush({ name: "createOnTheJobDocument" });
    };

    onMounted(() => onSearchDocuments());
    return {
      onTheJobs,
      onNewDocument,
      onEditDocument,
      formatAppDate,
      selectedDate,
      onSearchDocuments,
      divisions,
      departments,
      division,
      department,
    };
  },
});
</script>

<style></style>
